import { application } from "./application";

import AllmedsController from "./allmeds_controller";
import CatalogTabsController from "./catalog_tabs_controller";
import MeditationCardController from "./meditation_card_controller";
import PlayerController from "./player_controller";
import TotopController from "./totop_controller";
import WaveformController from "./waveform_controller";
import CheckoutController from "./checkout_controller";
import ConsentController from "./consent_controller";
import OtpController from "./otp_controller";
import ResendController from "./resend_controller";
import LocaleSwitchController from "./locale_switch_controller";
import RevealController from "./reveal_controller";
import ConversionController from "./conversion_controller";
application.register("allmeds", AllmedsController);
application.register("catalog-tabs", CatalogTabsController);
application.register("meditation-card", MeditationCardController);
application.register("player", PlayerController);
application.register("totop", TotopController);
application.register("waveform", WaveformController);
application.register("checkout", CheckoutController);
application.register("consent", ConsentController);
application.register("otp", OtpController);
application.register("resend", ResendController);
application.register("locale-switch", LocaleSwitchController);
application.register("reveal", RevealController);
application.register("conversion", ConversionController);
